import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'ทำไมต้องเรียน', href: '#painpoints' },
    { name: 'เนื้อหาหลักสูตร', href: '#curriculum' },
    { name: 'ปาจื้อคืออะไร', href: '#bazi-info' },
    { name: 'ค่าลงทะเบียน', href: '#pricing' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg py-3 border-b border-zinc-100' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <span className="logo-font font-black text-2xl tracking-tighter text-zinc-900 flex items-center">
              FENGSHUI<span className="text-brand-red text-3xl font-black">X</span>
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <a 
                key={link.name} 
                href={link.href} 
                className="text-[13px] font-black uppercase tracking-widest text-zinc-600 hover:text-brand-red transition-all duration-300 relative group"
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-red transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
            <a 
              href="#registration" 
              className="px-8 py-3 text-[13px] font-black uppercase tracking-[0.15em] text-white bg-zinc-900 hover:bg-brand-red transition-all duration-500 shadow-xl shadow-black/5"
            >
              สมัครเรียนทันที
            </a>
          </div>

          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="text-zinc-900 hover:text-brand-red focus:outline-none transition-colors">
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-7 w-7" />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden bg-white border-t border-zinc-100 shadow-2xl absolute w-full left-0"
          >
            <div className="px-6 pt-6 pb-10 space-y-6">
              {navLinks.map((link) => (
                <a 
                  key={link.name} 
                  href={link.href} 
                  className="block text-lg font-black text-zinc-800 hover:text-brand-red border-b border-zinc-50 pb-2"
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a 
                href="#registration" 
                onClick={() => setIsOpen(false)}
                className="block w-full py-5 text-center text-sm font-black uppercase tracking-widest text-white bg-brand-red"
              >
                สมัครเรียนทันที
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}